import React from "react";
import svgLoading from "../../public/images/svg/loading.svg";

const CostcoBlueLoader = (props: { loadingText?: string }) => (
  <div className="flex flex-grow items-center justify-center z-10">
    <div className="flex flex-col items-center">
      <div className="w-16 h-16">
        <img src={svgLoading} alt="loading..." />
      </div>
      {props.loadingText && (
        <div className="pt-4 text-lg text-center">{props.loadingText}</div>
      )}
    </div>
  </div>
);

export default CostcoBlueLoader;
